export { default } from './DuvidasFrequentes25Banner';
